(function(angular) {
    'use strict';

    /**
     * This directive checks if the the height (pixel) of the element's parent is bigger
     * then the given string value, and sets the css property 'max-height' to this value,
     * if so. Furthermore the element this directive is bound to gets a click function
     * to toggle this css property.
     *
     * If the parent is smaller then the given value, the element wil be hidden.
     */

    angular.module('um.commonDirectives').directive('ellipsisParent', ellipsisParentDirective);
    ellipsisParentDirective.$inject = ['$timeout'];
    function ellipsisParentDirective($timeout) {
        return {
            restrict : "A",
            link: function(scope, e, a) {
                let showFullElement = false;

                let toggleMaxHeight = function toggleMaxHeight() {
                    if (e.parent().attr('style')) {
                        e.parent().removeAttr('style');
                        showFullElement = true;
                    } else {
                        e.parent()
                            .css({
                                'max-height': a.ellipsisParent + 'px',
                                'overflow': 'hidden'
                            });
                        showFullElement = false;
                    }
                };

                e.bind('click', toggleMaxHeight);

                // has to been reworked in some way :D
                scope.$watch(() => e.parent().height(), (newVal) => {
                    if (newVal > a.ellipsisParent) {
                        if (!showFullElement) {
                            toggleMaxHeight();
                        }
                        e.css('display', 'block');
                    } else if (newVal < a.ellipsisParent) {
                        e.css('display', 'none');
                    } else if (!e.parent().attr('style')) {
                        e.css('display', 'none');
                    }
                });
            }
        };
    }
})(window.angular);
